import { LocalizedAttributesValueInterface } from './LocalizedAttributesValueInterface';

export type ScalarProductAttributes = {
  ID: string;
  Label: string;
  calcMinReqDpv: string;
  calcEffectiveDpv: string;
  calcEffectivePV: string;
  calcFlowVelocity: string;
}

export type ProductAttributes = {
  [Property in LocalizedAttributeNames]: LocalizedAttributesValueInterface | null
} & ScalarProductAttributes;

export const isAttributesClassInterface = (
  item: any,

): item is AttributesClassInterface => !!item && item.ID !== undefined && item.Label !== undefined;

export type AttributesClassInterface = {
  [Property in LocalizedAttributeNames as `_${Property}`]: LocalizedAttributesValueInterface | null
} & ScalarProductAttributes;

export type LocalizedAttributeNames = typeof LocalizedAttributesInstanceArray[number];

export const ReplacementAttributes: LocalizedAttributeNames[] = [
  '7240',
  '7603',
  '7598',
  '7655',
  '7688',
  '7704',
  '7597',
  '7680',
  '7704',
  '8404',
  '8405',
  '8465',
  '8466',
  '7767'
];

export const LocalizedAttributesInstanceArray = [
  '3718',
  '592',
  '7373',
  '6943',
  '906',
  '568',
  '7902',
  '7767',
  '7768',
  '7812',
  '7793',
  '8012',
  '7266',
  '880',
  '8457',
  '93',
  '442',
  '8516',
  '8517',
  '3477',
  '7765',
  '7766',
  '6351',
  '6350',
  '6349',
  '6322',
  '6323',
  '6325',
  '6326',
  '6327',
  '6328',
  '6329',
  '6330',
  '6331',
  '6332',
  '6333',
  '6334',
  '6335',
  '6336',
  '6337',
  '6338',
  '6339',
  '6340',
  '6341',
  '6342',
  '6343',
  '6344',
  '6345',
  '6346',
  '6347',
  '6348',
  '8543',
  '461',
  '417',
  '347',
  '6968',
  '6969',
  '148',
  '223',
  '65',
  '8162',
  '6666',
  '6560',
  '470',
  '472',
  '474',
  '7672',
  '7700',
  '7614',
  '7606',
  '7687',
  '2778',
  '3482',
  '83',
  '67',
  '68',
  '69',
  '6759',
  '260',
  '278',
  '118',
  '8160',
  '473',
  '230',
  '313',
  '3645',
  '3474',
  '135',
  '281',
  '120',
  '5695',
  '121',
  '122',
  '96',
  '144',
  '119',
  '112',
  '137',
  '156',
  '6287',
  '377',
  '406',
  '6314',
  '660',
  '7607',
  '7608',
  '7609',
  '7610',
  '7776',
  '8322',
  '7611',
  '8253',
  '8261',
  '8262',
  '7612',
  '7681',
  '7682',
  '7683',
  '7684',
  '7685',
  '7686',
  '7771',
  '7772',
  '7773',
  '7774',
  '7775',
  '7613',
  '7597',
  '8263',
  '8264',
  '8265',
  '8266',
  '7604',
  '7777',
  '7881',
  '7680',
  '7697',
  '7778',
  '7882',
  '7688',
  '7698',
  '7883',
  '7704',
  '7705',
  '7884',
  '581',
  '582',
  '7707',
  '7598',
  '7655',
  '7631',
  '7656',
  '7603',
  '6948',
  '890',
  '7706',
  '7708',
  '7709',
  '7710',
  '7711',
  '7712',
  '16',
  '7798',
  '7699',
  '7519',
  '15',
  '14',
  '78',
  '3460',
  '7153',
  '6670',
  '6561',
  '6667',
  '528',
  '886',
  '7801',
  '7906',
  '8255',
  '8028',
  '8256',
  '8386',
  '8387',
  '7797',
  '7800',
  '6673',
  '7836',
  '7983',
  '6994',
  '8534',
  '7786',
  '7694',
  '7844',
  '7885',
  '6517',
  '86',
  '87',
  '7977',
  '141',
  '142',
  '145',
  '7984',
  '8013',
  '8001',
  '8060',
  '8062',
  '8003',
  '8064',
  '7811',
  '8066',
  '8007',
  '8005',
  '8009',
  '8068',
  '8070',
  '8072',
  '8267',
  '3455',
  '7909',
  '7910',
  '7911',
  '7912',
  '7913',
  '7914',
  '7915',
  '7916',
  '7917',
  '7918',
  '7919',
  '7920',
  '7921',
  '7922',
  '7923',
  '7924',
  '7940',
  '7941',
  '7942',
  '7943',
  '7944',
  '7945',
  '7946',
  '7947',
  '7948',
  '7949',
  '7950',
  '7951',
  '7952',
  '7953',
  '7954',
  '7955',
  '8401',
  '8403',
  '6436',
  '754',
  '8404',
  '8405',
  '8465',
  '8466',
  '8445',
  '8444',
  '8443',
  '8442',
  '8441',
  '8440',
  '8439',
  '8502',
  '8501',
  '7615',
  '8002',
  '7802',
  '7805',
  '8447',
  '7809',
  '7810',
  '7808',
  '8171',
  '8159',
  '6691',
  '6084',
  '8581',
  '8107',
  '8507',
  '8318',
  '800',
  '5684',
  '504',
  '6601',
  '60',
  '656',
  '8729',
  '8242',
  '56',
  '6675',
  '5840',
  '22',
  '17',
  '26',
  '7240',
  '7241',
  '7242',
  // for vss
  '8165',
  '6744',
  '114',
  '8749',
  '8350',
  '23',
  '6516',
  '891',
  '32',
  '74',
  '24',
  '6808',
  '2798',
  '42',
  '8295',
  '8294',
  '6577',
  '3442',
  '6976',
  '6311',
  '510',
  '511',
  '7392',
  '7393',
  '7456',
  '3581',
  '6686',
  '6853',
  '6827',
  '8626',
  '8627',
  '5700',
  '8681',
  '8682',
  '8683',
  '8684',
  '8685',
  '8686',
  '8687',
  '548',
  '549',
  '7311',
  '8669',
  '8670',
  '8671',
  '8672',
  '8673',
  '8674',
  '8675',
  '8676',
  '8677',
  '8678',
  '8679',
  '8680',
  '360',
] as const;

export const LocalizedAttributesInstance = LocalizedAttributesInstanceArray.reduce((acc,
 obj) => ({...acc,
 [obj]: null}),
 {} as Record<LocalizedAttributeNames,
 null>);
